<aside class="history-panel" aria-label="Histórico de versões do modelo">
  <header class="history-panel__header">
    <div>
      <h3>Histórico de versões</h3>
      <p>Versões antigas ficam só para leitura.</p>
    </div>
    <button
      type="button"
      class="history-panel__close"
      pTooltip="Recolher histórico"
      tooltipPosition="left"
      aria-label="Recolher histórico"
      (click)="collapse.emit()">
      <i class="pi pi-angle-double-right"></i>
    </button>
  </header>

  @if (loading()) {
    <app-loading />
  } @else {
    <ol class="history-panel__list">
      @for (version of versions(); track version.id) {
        <li>
          <button
            type="button"
            class="history-panel__item"
            [class.history-panel__item--selected]="
              selectedId() === version.id || (!selectedId() && version.isCurrent)
            "
            (click)="selectVersion.emit(version)">
            <span
              class="history-panel__dot"
              [class.history-panel__dot--current]="version.isCurrent"></span>
            <span class="history-panel__body">
              <span class="history-panel__title">
                Versão {{ version.version }}
                @if (version.isCurrent) {
                  <span class="history-panel__badge">Vigente</span>
                }
              </span>
              <span class="history-panel__meta">
                {{ version.createdAt | vaultDateTime }}
                @if (version.createdByName) {
                  · {{ version.createdByName }}
                }
              </span>
              @if (version.changeNote) {
                <span class="history-panel__note">{{ version.changeNote }}</span>
              }
            </span>
          </button>
        </li>
      } @empty {
        <li class="history-panel__empty">Ainda não há versões salvas.</li>
      }
    </ol>
  }
</aside>
